export default __webpack_public_path__ + "static/media/38.6651ec48.png";